/** @format */

import React from 'react';

const CartOverviewContextDefault = {
    cartId: false,
    handleFetchCart: () => {},
    handleChange: () => {},
    handleChangeOrder: () => {},
    handleAllUploadsComplete: () => {},
    handleDeleteDesign: () => {},
    handleDeleteOrder: () => {},
    handleSavedToAccount: () => {}
};

const CartOverviewContext = React.createContext(CartOverviewContextDefault);

export {CartOverviewContext, CartOverviewContextDefault};
